import constants from './constants/constants'
import biErrors from './bi/errors'
import bi from './bi/bi'
import account from './account/account'
import partners from './partners/partners'
import environment from './environment/environment'
import events from './bi/events'
import biEventTypes from './bi/events.json'
import siteMetadataPropertiesInfo from './pathHelpers/siteMetadataPropertiesInfo'
import siteMetadata from './siteMetadata/siteMetadata'
import clientSpecMap from './siteMetadata/clientSpecMap'
import componentStructureInfo from './component/componentStructureInfo'
import componentModes from './component/componentModes'
import componentsLoader from './componentsLoader/componentsLoader'
import customElements from './customElements/customElements'
import responsiveLayout from './responsiveLayout/responsiveLayout'
import breakpoints from './responsiveLayout/breakpoints'
import responsiveLayoutValidations from './responsiveLayout/validations'
import scrollAnchors from './scrollAnchors/scrollAnchors'
import variants from './variants/variants'
import design from './variants/design'
import transformations from './variants/transformations'
import transitions from './variants/transitions'
import documentServicesDataFixer from './documentServicesDataFixer/documentServicesDataFixer'
import dataFixersConfig from './documentServicesDataFixer/dataFixersConfig'
import mobilePreSaveOperation from './saveAPI/preSaveOperations/plugins/mobilePreSaveOperation'
import autosave from './autosave/autosave'
import atomicScopes from './atomicScopes/atomicScopes'
import componentLayout from './structure/utils/componentLayout'
import structure from './structure/structure'
import documentMode from './documentMode/documentMode'
import dataModel from './dataModel/dataModel'
import componentsDataModel from './dataModel/componentsDataModel'
import features from './features/features'
import slots from './slots/slots'
import states from './states/states'
import triggers from './triggers/triggers'
import reactions from './reactions/reactions'
import page from './page/page'
import pageRemoval from './page/pageRemoval'
import pageAdd from './page/pageAdd'
import pageUtils from './page/pageUtils'
import sectionsLayoutMigrator from './sectionsLayoutMigrator/sectionsLayoutMigrator'
import modesUtils from './modes/modesUtils'
import dataIds from './dataModel/dataIds'
import utils from './utils/utils'
import {contextAdapter} from './utils/contextAdapter'
import hooks from './hooks/hooks'
import errors from './errors/errors'
import idGenerator from './utils/idGenerator'
import skipToContentData from './accessibility/skipToContentData'
import visualFocusData from './accessibility/visualFocusData'
import languageDirection from './accessibility/languageDirection'
import autoDomReorderData from './accessibility/autoDomReorderData'
import componentA11yAPI from './accessibility/componentA11yAPI'
import actionsAndBehaviors from './actionsAndBehaviors/actionsAndBehaviors'
import motion from './motion/motion'
import canvas from './canvas/canvas'
import appControllerData from './appControllerData/appControllerData'
import appStudio from './appStudio/appStudio'
import appStudioWidgets from './appStudioWidgets/appStudioWidgets'
import componentDetectorAPI from './componentDetectorAPI/componentDetectorAPI'
import component from './component/component'
import componentInit from './component/componentInit'
import refComponent from './refComponent/refComponent'
import snapshotAPI from './snapshotAPI/snapshotAPI'
import stylableEditorAPI from './stylableEditor/stylableEditorAPI'
import componentStylesAndSkinsAPI from './component/componentStylesAndSkinsAPI'
import componentCode from './component/componentCode'
import componentBehaviors from './component/componentBehaviors'
import componentScroll from './component/componentScroll'
import mobileActions from './mobileConversion/mobileActions'
import componentsMetaData from './componentsMetaData/componentsMetaData'
import createCompDriver from './hooks/componentsExternalHooks/createCompDriver'
import connections from './connections/connections'
import feedback from './feedback/feedback'
import fonts from './fonts/fonts'
import inlinePopup from './inlinePopup/inlinePopup'
import browserThemeColor from './browserThemeColor/browserThemeColor'
import layouters from './layouters/layouters'
import globalImageQualityData from './media/globalImageQualityData'
import vectorImageAPI from './media/vectorImageAPI'
import svgFiltersDefinitions from './media/svgFiltersDefinitions'
import mainMenu from './menu/mainMenu'
import menuAPI from './menu/menuAPI'
import basicMenuItemMethods from './menu/basicMenuItemMethods'
import mobileConversionFacade from './mobileConversion/mobileConversionFacade'
import mobileSettings from './mobileConversion/mobileEditorSettings/mobileSettings'
import quickActions from './mobileConversion/mobileEditorSettings/quickActions'
import quickActionsVersionUtils from './mobileConversion/mobileEditorSettings/quickActionsVersionUtils'
import quickActionBarManager from './mobileConversion/mobileEditorSettings/quickActionBarManager'
import mergeAggregator from './mobileConversion/modules/mergeAggregator'
import mobileHintsValidator from './mobileConversion/modules/mobileHintsValidator'
import mobilePresetsHandler from './mobileConversion/modules/mobilePresets/mobilePresetsHandler'
import menuContainer from './mobileConversion/modules/menuContainer/menuContainer'
import wix2x from './wix2x/wix2x'
import pageData from './page/pageData'
import pagesGroup from './pagesGroup/pagesGroup'
import platform from './platform/platform'
import provision from './platform/provision'
import addApps from './platform/addApps'
import uninstall from './platform/uninstall'
import platformPages from './platform/pages'
import serialization from './platform/serialization'
import sessionState from './platform/sessionState'
import viewerInfoChangedEmitter from './platform/services/viewerInfoChangedEmitter'
import apiCallBiService from './platform/services/apiCallBiService'
import livePreview from './platform/livePreview/livePreview'
import platformConstants from './platform/common/constants'
import renderPlugins from './renderPlugins/renderPlugins'
import routers from './routers/routers'
import saveAPI from './saveAPI/saveAPI'
import siteMembers from './siteMembers/siteMembers'
import siteSegments from './siteSegments/siteSegments'
import smartBoxes from './smartBoxes/smartBoxes'
import multiComponentsUtils from './smartBoxes/multiComponentsUtils'
import multiComponentsUtilsValidations from './smartBoxes/multiComponentsUtilsValidations'
import grouping from './smartBoxes/grouping'
import groupingUtils from './smartBoxes/groupingUtils'
import structureUtils from './structure/structureUtils'
import arrangement from './structure/utils/arrangement'
import meshMigrationUtil from './structure/meshMigrationUtil'
import theme from './theme/theme'
import tpa from './tpa/tpa'
import tpaCore from './tpa/core'
import wixCode from './wixCode/wixCode'
import cms from './cms/cms'
import wixapps from './wixapps/wixapps'
import wixCodeConstants from './wixCode/utils/constants'
import * as wFacebookComment from './hooks/componentHooks/wFacebookComment'
import variables from './variables/variables'
import scopes from './scopes/scopes'
import scopesMetaData from './scopes/metaData/scopesMetaData'
import siteWidth from './structure/siteWidth/siteWidth'
import './hooks/hooksRegistrarLoader'
import patterns from './patterns/patterns'
import effects from './effects/effects'
import {ajaxLibrary} from '@wix/santa-ds-libs'
import customCSS from './customCSS/customCSS'
import ai from './ai/ai'
import externalComponents from './externalComponents/externalComponents'
import importExport from './importExport/importExport'
import debug from './debug/debug'
import builderComponents from './builderComponents/builderComponents'
import appStoreService from './tpa/services/appStoreService'
import responsify from './responsify/responsify'
import {locales} from './locales/locales'

const biEvents = events
const wixCodeDS = wixCode

const getAjaxLibrary = () => ajaxLibrary

export {
    constants,
    biErrors,
    bi,
    account,
    partners,
    environment,
    biEvents,
    biEventTypes,
    siteMetadataPropertiesInfo,
    siteMetadata,
    clientSpecMap,
    componentStructureInfo,
    componentModes,
    componentsLoader,
    customElements,
    responsiveLayout,
    breakpoints,
    responsiveLayoutValidations,
    variants,
    design,
    transformations,
    transitions,
    scrollAnchors,
    documentServicesDataFixer,
    dataFixersConfig,
    mobilePreSaveOperation,
    autosave,
    atomicScopes,
    componentLayout,
    structure,
    documentMode,
    dataModel,
    componentsDataModel,
    features,
    slots,
    states,
    triggers,
    reactions,
    page,
    pageRemoval,
    pageAdd,
    pageUtils,
    sectionsLayoutMigrator,
    modesUtils,
    dataIds,
    utils,
    contextAdapter,
    hooks,
    wixCodeDS,
    platform,
    wixCodeConstants,
    wFacebookComment,
    variables,
    scopes,
    patterns,
    scopesMetaData,
    effects,
    errors,
    idGenerator,
    skipToContentData,
    visualFocusData,
    languageDirection,
    autoDomReorderData,
    componentA11yAPI,
    actionsAndBehaviors,
    motion,
    canvas,
    appControllerData,
    appStudio,
    appStudioWidgets,
    componentDetectorAPI,
    component,
    componentInit,
    refComponent,
    snapshotAPI,
    stylableEditorAPI,
    componentStylesAndSkinsAPI,
    componentCode,
    componentBehaviors,
    componentScroll,
    mobileActions,
    componentsMetaData,
    createCompDriver,
    connections,
    feedback,
    fonts,
    inlinePopup,
    browserThemeColor,
    layouters,
    globalImageQualityData,
    vectorImageAPI,
    svgFiltersDefinitions,
    mainMenu,
    menuAPI,
    basicMenuItemMethods,
    mobileConversionFacade,
    mobileSettings,
    quickActions,
    quickActionsVersionUtils,
    quickActionBarManager,
    mergeAggregator,
    mobileHintsValidator,
    mobilePresetsHandler,
    menuContainer,
    wix2x,
    pageData,
    pagesGroup,
    provision,
    addApps,
    uninstall,
    platformPages,
    serialization,
    sessionState,
    viewerInfoChangedEmitter,
    apiCallBiService,
    livePreview,
    platformConstants,
    renderPlugins,
    routers,
    saveAPI,
    siteMembers,
    siteSegments,
    siteWidth,
    smartBoxes,
    multiComponentsUtils,
    multiComponentsUtilsValidations,
    grouping,
    groupingUtils,
    structureUtils,
    arrangement,
    meshMigrationUtil,
    theme,
    tpa,
    tpaCore,
    wixCode,
    cms,
    wixapps,
    getAjaxLibrary,
    customCSS,
    ai,
    externalComponents,
    importExport,
    builderComponents,
    debug,
    appStoreService,
    responsify,
    locales
}
